import React from 'react'
import SimpleSpinner from '../Common/SimpleSpinner'
import { Route, Routes } from 'react-router-dom'

const LearningMG = React.lazy(() => import('src/containers/Learning/LearningMG'))
const LearningCS = React.lazy(() => import('src/containers/Learning/LearningCS'))
const EducationalPartnersMap = React.lazy(() => import('src/containers/Learning/EducationalPartnersMap'))
const Error404 = React.lazy(() => import('src/containers/Error404'))

const EducationRoutes = () => {
  return (
    <React.Suspense fallback={<SimpleSpinner />}>
      <Routes>
        <Route path='/matrixgold' element={<LearningMG />} />
        <Route path='/countersketch' element={<LearningCS />} />
        <Route path='/educational-partners' element={<EducationalPartnersMap />} />
        <Route path='*' element={<Error404 />} />
      </Routes>
    </React.Suspense>
  )
}

export default EducationRoutes
